/* RAFALE — galerie, offres (variantes ou quantité 1/2/3), barre d'achat collante. Autonome (aucune dépendance). */
(function () {
  function initGallery() {
    document.querySelectorAll('[data-rf-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-rf-main]');
      g.querySelectorAll('[data-rf-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (main) { main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || ''; }
          g.querySelectorAll('[data-rf-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
        });
      });
    });
  }
  function initBundles() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var id = form.querySelector('[data-rf-id]');
    var qty = form.querySelector('[data-rf-qty]');
    var now = document.querySelector('[data-rf-price]');
    var was = document.querySelector('[data-rf-was]');
    var save = document.querySelector('[data-rf-save]');
    var atcPrice = document.querySelector('[data-rf-atc-price]');
    var stickyPrice = document.querySelector('[data-rf-sticky-price]');
    var stickyId = document.querySelector('[data-rf-sticky-id]');
    var stickyQty = document.querySelector('[data-rf-sticky-qty]');
    var btn = form.querySelector('[data-add-btn]');
    function apply(input) {
      var v = input.value;
      if (input.name === 'rf-qty') {
        /* Offre par quantité : même variante, quantité 1 / 2 / 3 */
        if (qty) qty.value = v;
        if (stickyQty) stickyQty.value = v;
      } else {
        if (id) id.value = v;
        if (stickyId) stickyId.value = v;
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v); window.history.replaceState({}, '', url.toString());
        }
      }
      var p = input.getAttribute('data-price-text'), c = input.getAttribute('data-compare-text'), s = input.getAttribute('data-save-text');
      if (now) now.textContent = p;
      atcPrice = document.querySelector('[data-rf-atc-price]');
      if (atcPrice) atcPrice.textContent = p;
      else if (btn && btn.getAttribute('data-label-add')) btn.textContent = btn.getAttribute('data-label-add') + ' — ' + p;
      if (stickyPrice) stickyPrice.textContent = p;
      if (was) { was.textContent = c || ''; was.hidden = !c; }
      if (save) { save.textContent = s || ''; save.hidden = !s; }
      var available = input.getAttribute('data-available') === 'true';
      if (btn) { btn.disabled = !available; }
      form.querySelectorAll('.rf-bundle').forEach(function (l) { l.classList.toggle('is-on', l.contains(input)); });
    }
    form.querySelectorAll('input[name="rf-variant"], input[name="rf-qty"]').forEach(function (input) {
      input.addEventListener('change', function () { apply(input); });
    });
    var checked = form.querySelector('input[name="rf-variant"]:checked, input[name="rf-qty"]:checked');
    if (checked) apply(checked);
    /* Les boutons radio ne doivent pas partir avec le formulaire d'ajout au panier */
    form.addEventListener('formdata', function (e) { e.formData.delete('rf-variant'); e.formData.delete('rf-qty'); });
    initGift(form, btn);
  }
  /* Cadeau offert : dès la quantité minimale, on ajoute le produit offert dans la même requête.
     La réduction automatique Shopify « Achetez X, obtenez Y » le rend gratuit au paiement. */
  function initGift(form, btn) {
    var gift = form.querySelector('[data-rf-gift-id]');
    if (!gift || !window.Routes) return;
    var giftId = parseInt(gift.value, 10), minQty = parseInt(gift.getAttribute('data-rf-gift-min'), 10) || 2;
    var mainVariant = parseInt(gift.getAttribute('data-rf-main-id'), 10);
    try { localStorage.setItem('rf-gift', JSON.stringify({ gift: giftId, main: mainVariant, min: minQty })); } catch (err) {}
    form.addEventListener('submit', function (e) {
      var qtyInput = form.querySelector('[data-rf-qty]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (qty < minQty) return; /* vitaly.js gère l'ajout normal */
      e.preventDefault(); e.stopImmediatePropagation();
      var idInput = form.querySelector('[data-rf-id]');
      var mainId = idInput ? parseInt(idInput.value, 10) : null;
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-label-adding') || 'Ajout…'; }
      fetch(window.Routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasGift = (cart.items || []).some(function (i) { return i.variant_id === giftId; });
          var items = [{ id: mainId, quantity: qty }];
          if (!hasGift) items.push({ id: giftId, quantity: 1 });
          return fetch(window.Routes.cart_add_url, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Ajout impossible');
          return refreshDrawer();
        })
        .then(function () {
          var opener = document.querySelector('[data-drawer-open="cart-drawer"]');
          if (opener) opener.click();
        })
        .catch(function (err) {
          var slot = form.querySelector('[data-form-error]');
          if (slot) { slot.textContent = err.message; slot.hidden = false; }
        })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    }, true);
  }
  /* Nettoyage : si le panier contient le cadeau mais moins que la quantité minimale du produit principal, on retire le cadeau. */
  function cleanGift() {
    if (!window.Routes) return;
    var cfg = null;
    try { cfg = JSON.parse(localStorage.getItem('rf-gift') || 'null'); } catch (err) {}
    if (!cfg) return;
    fetch(window.Routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [], mainQty = 0, giftLine = 0;
        items.forEach(function (it, i) {
          if (it.variant_id === cfg.main) mainQty += it.quantity;
          if (it.variant_id === cfg.gift) giftLine = i + 1;
        });
        if (!giftLine || mainQty >= cfg.min) return;
        return fetch(window.Routes.cart_change_url, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: giftLine, quantity: 0 })
        }).then(function () {
          if (document.body.classList.contains('template-cart')) window.location.reload(); else return refreshDrawer();
        });
      })
      .catch(function () {});
  }
  function refreshDrawer() {
    return fetch(window.Routes.cart_url + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        var countEl = parsed.querySelector('[data-cart-item-count]');
        var count = countEl ? parseInt(countEl.getAttribute('data-cart-item-count'), 10) || 0 : null;
        if (count !== null) document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
      });
  }
  function initSticky() {
    var bar = document.querySelector('[data-rf-sticky]');
    var anchor = document.querySelector('[data-rf-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }).observe(anchor);
  }
  function init() { initGallery(); initBundles(); initSticky(); }
  /* Après chaque changement de ligne du panier (vitaly.js recharge le tiroir), on revérifie le cadeau. */
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('[data-cart-qty]')) setTimeout(cleanGift, 1200); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-cart-remove]')) setTimeout(cleanGift, 1200); });
  if (document.body.classList.contains('template-cart')) setTimeout(cleanGift, 300);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
